// 添加语音播报全局方法
export default {
  install(Vue, options = {}) {
    const base = (process && process.env && process.env.BASE_URL) ? process.env.BASE_URL : "/";
    const successPath = (options.successPath) ? options.successPath : `${base}audio/ScanSuccess.mp3`;
    const failurePath = (options.failurePath) ? options.failurePath : `${base}audio/ScanFailure.mp3`;

    Vue.prototype.$playScanSuccess = function playScanSuccess() {
      try {
        const audio = new Audio(successPath);
        const p = audio.play();
        if (p && p.catch) p.catch(() => {});
      } catch (e) {
        // swallow errors
      }
    };

    Vue.prototype.$playScanFailure = function playScanFailure() {
      try {
        const audio = new Audio(failurePath);
        const p = audio.play();
        if (p && p.catch) p.catch(() => {});
      } catch (e) {
        // swallow errors
      }
    };
  },
};
